module.exports = __webpack_public_path__ + "img/home1.108e4e45.png";